import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { IStatusType } from '../../../model/common.model'
import { MatError, MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import {  MatInputModule } from '@angular/material/input';
import { MatTable } from '@angular/material/table';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { EcaFormColumnModule } from '@drc-eca/eca-components-lib';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-add-update-status-type-modal',
    standalone: true,
    templateUrl: './add-update-status-type-modal.component.html',
    styleUrls: ['./add-update-status-type-modal.component.scss'],
    imports: [
      MatFormFieldModule,
      MatInputModule,
      MatDialogModule,
      MatSelectModule,
      MatError,
      MatIcon,
      MatButtonModule,
      MatSelect,
      EcaFormColumnModule,
      MatFormField,
      CommonModule,
      FormsModule,
      ReactiveFormsModule
    ]  
})
export class AddUpdateStatusTypeModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<AddUpdateStatusTypeModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  private colorPattern = '^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$';
  private statusTypes: IStatusType[] = [];

  form: UntypedFormGroup = new UntypedFormGroup({
    statusName: new UntypedFormControl(null, Validators.required),
    statusPrecedence: new UntypedFormControl(null, Validators.required),
    statusMessage: new UntypedFormControl(null, [Validators.required, Validators.minLength(10), Validators.maxLength(255)]),
    showServiceList: new UntypedFormControl(false, Validators.required),
    statusColorCode: new UntypedFormControl(null, Validators.required),
    statusColorCodeOther: new UntypedFormControl(null)
  });
  action: string = 'Add';
  colorCodes: string[] = [
    '#FF0000',
    '#FFA500',
    '#FFFF00',
    '#228B22',
    '#800080',
    '#00FFFF'
  ];

  constructor() {
    const data = this.data;

    if (data.statusTypes) {
      this.statusTypes = data.statusTypes;
    }
    if (data.selectedStatusType) {
      this.action = 'Update';
      const selectedStatusType: IStatusType = {
        statusName: data.selectedStatusType.statusName,
        statusPrecedence: data.selectedStatusType.statusPrecedence,
        statusMessage: data.selectedStatusType.statusMessage,
        primaryKeyPart: data.selectedStatusType.primaryKeyPart,
        secondaryKeyPart: data.selectedStatusType.secondaryKeyPart,
        showServiceList: data.selectedStatusType.showServiceList ? true : false,
        statusColorCode: data.selectedStatusType.statusColorCode.toUpperCase()
      };
      this.form.patchValue(selectedStatusType);      
      if (!this.colorCodes.map(c => c.toUpperCase()).includes(data.selectedStatusType.statusColorCode.toUpperCase())) {
        this.colorCodes.push(data.selectedStatusType.statusColorCode.toUpperCase());
      }
    }
  }

  ngOnInit(): void {
  }

  checkColorChoosen() {
    this.form.controls.statusColorCodeOther.reset;
    this.form.controls.statusColorCodeOther.clearValidators();
    this.form.controls.statusColorCodeOther.setValue('');
    this.form.controls.statusColorCodeOther.updateValueAndValidity();
    if (this.form.controls.statusColorCode.value && this.form.controls.statusColorCode.value == 'Other') {
      this.form.controls.statusColorCodeOther.setValidators([Validators.required, Validators.pattern(this.colorPattern)]);
      this.form.controls.statusColorCodeOther.updateValueAndValidity();
    }
  }

}
